import { PaymentIcon } from './NuskinPaymentIcon'
export { PaymentIcon }
export default PaymentIcon
